// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{text-transform:none!important}a{-webkit-text-decoration:none;text-decoration:none}.v-text-field>.v-input__control>.v-input__slot,.v-textarea>.v-input__control>.v-input__slot{transition:background .3s cubic-bezier(.25,.8,.5,1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
